import React from "react";

export default function MySQL_CONCAT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_CONCAT</h1>
      <p>This is the MySQL_CONCAT component generated from the SQL JSON.</p>
    </div>
  );
}
